"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = {
  saveRef: function saveRef(name) {
    var _this = this;

    return function (node) {
      _this[name] = node;
    };
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/rc-tabs/lib/RefMixin.js
// module id = 581
// module chunks = 35783957827783 65974612472484